import React, {createContext, useContext} from 'react';
import {FormikProvider, useFormik} from 'formik';
import * as actions from '../_redux/unpaidAgentsActions';
import {checkEmailIsValid} from '../../_common/utils/checkEmailIsValid';

const PopupSendMessageContext = createContext();

export function usePopupSendMessageContext() {
  return useContext(PopupSendMessageContext);
}

export function PopupSendMessageProvider({children, cellContent}) {
  const {
    isOtherIncomeExists,
    form101FileExists,
    taxAdjustmentFileExists,
    phone, email
  } = cellContent;
  const only101Missing = [
    'שלום,',
    'נדרש למלא טופס 101 חדש לשנת 2026.',
    'הטופס זמין למילוי בקישור:',
    'https://system.atzmai.co.il/goToRegistrationForm101',
    'אפשרות נוספת: כניסה לאזור האישי במערכת ומילוי הטופס תחת "טפסי הרשמה".',
    'לתשומת לבך: ללא טופס 101 מעודכן לא ניתן להעביר שכר.',
    'שימו לב: לא ניתן להשיב להודעה זו.',
    'לפניות יש לפנות במייל או בוואטסאפ בלבד.',
  ].filter(Boolean).join('\n');
  const onlyTaxAdjustmentMissing = [
    'שלום,',
    'בטופס 101 סימנת בסעיף ה\' כי קיימת לך הכנסה נוספת.',
    'עליך להעביר אלינו תיאום מס תקף. ללא תיאום מס לא ניתן לשלם שכר.',
    'שימו לב: יש לבצע תיאום מס עבור שני מעסיקים, מקום העבודה העיקרי ועבורנו.',
    'תיק הניכויים שלנו: 918043852',
    'קישור לביצוע תיאום מס:',
    'https://secapp.taxes.gov.il/logon/LogonPoint/tmindex.html',
    'אם אין לך הכנסה נוספת בפועל, יש למלא מחדש את טופס 101 ולסמן כי אין הכנסה נוספת.',
    'שימו לב: לא ניתן להשיב להודעה זו.',
    'לפניות יש לפנות במייל או בוואטסאפ בלבד.',
  ].filter(Boolean).join('\n');
  const bothMissing = [
    'שלום,',
    'נדרש למלא טופס 101 חדש לשנת 2026.',
    'הטופס זמין למילוי בקישור:',
    'https://system.atzmai.co.il/goToRegistrationForm101',
    'אפשרות נוספת: כניסה לאזור האישי במערכת ומילוי הטופס תחת "טפסי הרשמה".',
    'לתשומת לבך: ללא טופס 101 מעודכן לא ניתן להעביר שכר.',
    'בנוסף,',
    'בטופס 101 סימנת בסעיף ה\' כי קיימת לך הכנסה נוספת.',
    'עליך להעביר אלינו תיאום מס תקף. ללא תיאום מס לא ניתן לשלם שכר.',
    'שימו לב: יש לבצע תיאום מס עבור שני מעסיקים, מקום העבודה העיקרי ועבורנו.',
    'תיק הניכויים שלנו: 918043852',
    'קישור לביצוע תיאום מס:',
    'https://secapp.taxes.gov.il/logon/LogonPoint/tmindex.html',
    'אם אין לך הכנסה נוספת בפועל, יש למלא מחדש את טופס 101 ולסמן כי אין הכנסה נוספת.',
    'שימו לב: לא ניתן להשיב להודעה זו.',
    'לפניות יש לפנות במייל או בוואטסאפ בלבד.',
  ].filter(Boolean).join('\n');

  const getInitialMessage = () => {
    if (isOtherIncomeExists) {
      if (!form101FileExists && taxAdjustmentFileExists) {
        return only101Missing;
      } else if (form101FileExists && !taxAdjustmentFileExists) {
        return onlyTaxAdjustmentMissing;
      } else if (!form101FileExists && !taxAdjustmentFileExists) {
        return bothMissing;
      }
    } else {
      if (!form101FileExists) {
        return only101Missing;
      } else return '';
    }
  };

  const formik = useFormik({
    initialValues: {
      sendSMS: false,
      sendEmail: false,
      phone: phone || '',
      email: email || '',
      message: getInitialMessage(),
    },
    onSubmit: () => {
    },
    validate: (values) => {
      let errors = {};
      const {sendSMS, sendEmail, phone, email, message} = values;
      if (!sendSMS && !sendEmail) errors.sendBy = 'Required';
      if (sendEmail && !checkEmailIsValid(email)) errors.invalidEmail = 'Invalid email';
      if (!message) errors.message = 'Required';
      if (sendSMS && !phone) errors.phone = 'Required';
      if (sendEmail && !email) errors.phone = 'Required';

      return errors;
    },
    validateOnMount: true,
    enableReinitialize: true,
  });

  const handleSendMessage = async () => {
    await actions.sendMessage(
      formik.values.sendSMS ? formik.values.phone : '',
      formik.values.sendEmail ? formik.values.email : '',
      formik.values.message
    );
  };

  return (
    <PopupSendMessageContext.Provider value={{
      formik,
      handleSendMessage
    }}>
      <FormikProvider value={formik}>{children}</FormikProvider>
    </PopupSendMessageContext.Provider>
  );
}
